import React from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'

import './BatteryMap.css'
import { BackButton } from '@/components/layout/NavBar'
import BatteryMapComponent from '@/components/Map/BatteryMap'
import { useAppContext } from '@/context/app'
import { useModal } from '@/components/modal/Modal'
import { Spinner } from '@/components/spinner'

export const BatteryMapPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const { translates } = session

  return <LoggedInPageLayout pageName='dashboard-battery-map' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <BatteryMapHelpPopupButton />

    <div className='default-map-container'>
      <BatteryMapComponent fetchUrl='/api/communal/map' services={services} session={session} />
    </div>
  </LoggedInPageLayout>
}

function BatteryMapHelpPopupButton() {
  const { translates } = useAppContext()
  const { openModal } = useModal()
  return <div className='page-help-button' onClick={() => openModal(({ onClose }: { onClose: () => void }) => {
    if (translates === undefined) {
      return
    }
    return BatteryMapHelpPopupBody({ onClose })
  })}>
    <i className='svgfont-help' />
  </div>
}

function BatteryMapHelpPopupBody({  onClose }: {
  onClose: () => void
}) {
  const { translates } = useAppContext()
  if (translates === undefined) {
    return <Spinner />
  }
  return (
    <div className='help-popup-body'>
      <h3>{translates.for("page.communal-battery-map.help.title")}</h3>

      <div className="help-popup-content">{translates.for("page.communal-battery-map.help.content")}</div>

      <table style={{
        fontWeight: 'bold',
        padding: '0 16px'
      }}>
        <tbody>
          <tr className="map-battery-green">
            <td>71 - 100%</td>
            <td>{translates.for("page.communal-battery-map.help.colors.green")}</td>
          </tr>
          <tr className="map-battery-yellow">
            <td>41 - 70%</td>
            <td>{translates.for("page.communal-battery-map.help.colors.green")}</td>
          </tr>
          <tr className="map-battery-orange">
            <td>21 - 40%</td>
            <td>{translates.for("page.communal-battery-map.help.colors.orange")}</td>
          </tr>
          <tr className="map-battery-red">
            <td>0 - 20%</td>
            <td>{translates.for("page.communal-battery-map.help.colors.red")}</td>
          </tr>
        </tbody>
      </table>

    </div>
  )
}
